// src/features/users/components/UserManagement/UserListCard/index.jsx
import React from 'react';
import Button from '../../../../../shared/components/ui/Button';
import { useAuth } from '../../../../auth/context/AuthContext';
import styles from './UserListCard.module.css';

const getInitials = (user) => {
  const name = `${user.first_name || ''} ${user.last_name || ''}`.trim() || user.username || '؟';
  return name.slice(0, 2).toUpperCase();
};

function UserListCard({ users, onEditClick, loading }) {
  const { canAccess } = useAuth();

  if (loading) {
    return (
      <div className={styles.card} style={{ alignItems: 'center', justifyContent: 'center', minHeight: '300px' }}>
        <p className="text-muted">جاري تحميل المستخدمين...</p>
      </div>
    );
  }

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <h2 className={styles.title}>المستخدمون الحاليون</h2>
        <span className={styles.countBadge}>{users.length}</span>
      </div>

      {users.length === 0 ? (
        <div className="flex-center flex-col gap-3" style={{ padding: '3rem 0', opacity: 0.5 }}>
          <span style={{ fontSize: '3rem' }}>👥</span>
          <p className="text-muted">لا يوجد مستخدمون حتى الآن.</p>
        </div>
      ) : (
        <div className={styles.listContainer}>
          {users.map(user => {
            const roleKey   = user.role_key || 'employee';
            const roleLabel = user.role     || roleKey;
            const depts     = user.departments || [];

            return (
              <div key={user.id} className={styles.userRow}>
                
                {/* الصورة الشخصية */}
                <div className={styles.avatar}>
                  {user.avatar ? (
                    <img 
                      src={user.avatar} 
                      alt={user.username} 
                      onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }}
                    />
                  ) : null}
                  <span className={styles.avatarInitials} style={{ display: user.avatar ? 'none' : 'flex' }}>
                    {getInitials(user)}
                  </span>
                </div>

                {/* بيانات المستخدم */}
                <div className={styles.userInfo}>
                  <span className={styles.userName}>{user.username}</span>
                  {(user.first_name || user.last_name) && (
                    <span className={styles.userFullName}>
                      {user.first_name} {user.last_name}
                    </span>
                  )}
                  
                  <div className={styles.userMeta}>
                    {user.email && <span className={styles.userEmail}>{user.email}</span>}
                    {depts.length > 0 && (
                      <span className={styles.userEmail} style={{ background: 'var(--color-primary-subtle)', color: 'var(--color-primary-text)' }}>
                        {depts.map(d => d.name).join(' | ')}
                      </span>
                    )}
                  </div>
                </div>

                {/* شارة الدور */}
                <span className={`${styles.roleBadge} ${styles[`role_${roleKey}`] || styles.role_employee}`}>
                  {roleLabel}
                </span>

                {/* الأزرار */}
                {canAccess('users') && (
                  <div className={styles.actions}>
                    <Button variant="outlinePrimary" size="sm" onClick={() => onEditClick(user)}>
                      تعديل ✏️
                    </Button>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default UserListCard;